import { oldHandleChartData } from "./oldData.js"
import { handleHotData } from "./hotMap.js"
import { handleScatterData } from "./scatterMap.js"
import { handleLineData } from "./lineMap.js"
export default {
  oldHandleChartData,
  handleHotData,
  handleScatterData,
  handleLineData
}
